export const environment = {
  production: false,
  apiBaseUrl: "https://api-94772-agent-eval-service.patient-np.davita.com",
  llmServiceBaseUrl:
    "https://api-94772-llm-service.patient-np.davita.com/api/llm-service/v1",
  llmServiceKey: "GUXEAK1I1s0f2G78ebb6sxbiZ8cd5Rj4PrEJlXLuNpA",
  authorization: {
    patient: {
      issuer_uri:
        "https://iam.api-c68e6.patient-np.davita.com/patient-sso/info",
      client_id: "UPP",
      client_secret: "not-required-but-need-some-text",
      redirect_uri: window.location.origin + "/login",
      scope: "openid",
      login_type: "patient",
    },
    teammate: {
      issuer_uri: "https://ping-auth-proxy.patient.davita.com/auth-app/Proxy",
      client_id: "IPS_DEV_Client",
      client_secret:
        "cKQa879pv4F36bkSR6TDChYEBKw0mUU9HsyfWvIBk4fQZiQ2z9uaQCoV0jZOoeQU",
      redirect_uri: window.location.origin + "/teammate-login",
      scope: "openid",
      login_type: "teammate",
    },
  },
};
